var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 459,
    height: 459,
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    id: "_x32_7_x2C__PDF_x2C__File_type_x2C__Adobe"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    id: "svg_1"
  }, /*#__PURE__*/React.createElement("polygon", {
    stroke: "null",
    id: "svg_2",
    fill: "#F1F1F1",
    points: "353.8156433105469,1.251824140548706 420.3463134765625,67.99199676513672 420.0894775390625,68.237548828125 354.3811340332031,68.28711700439453 353.7672119140625,1.3013882637023926 "
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_3",
    fill: "#F1F1F1",
    d: "m175.21185,106.59363c0,12.66296 -7.07378,18.64413 -17.93112,18.55852c-1.48572,0 -3.1449,0 -4.16316,-0.23316l0,-34.67276c1.01826,-0.23316 2.75066,-0.47872 5.42811,-0.47872c10.29189,0.00113 16.74052,5.82235 16.66618,16.82612z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_4",
    fill: "#F1F1F1",
    d: "m121.57731,97.39547c0,5.42811 -3.93113,8.65862 -10.29189,8.65862c-1.7324,0 -2.99734,-0.08561 -4.01673,-0.31877l0,-15.64791c0.87183,-0.23316 2.5175,-0.46633 4.94939,-0.46633c5.98117,0 9.35924,2.89822 9.35924,7.77439z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_5",
    fill: "#F1F1F1",
    d: "m81.6116,47.86215l206.33572,0l0,119.13454l-206.33572,0l-0.5035,0l-43.7121,0l0,-119.13454l43.71098,0l0.50463,0z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_6",
    fill: "#DC1D00",
    d: "m256.80244,228.50475c0.14643,12.36784 -7.76313,36.50091 -7.76313,36.50091c-2.72813,-2.87344 -8.18102,-18.25102 -8.18102,-32.47404c0,-14.22189 4.59457,-18.10233 8.18102,-18.10233c3.59771,0 7.61332,1.72001 7.76313,14.07546z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_7",
    fill: "#DC1D00",
    d: "m342.92228,336.36518c0,16.33501 -29.59947,9.67688 -47.80205,-7.65274c0,0 47.80205,-8.67101 47.80205,7.65274z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_8",
    fill: "#DC1D00",
    d: "m171.15907,390.15967c-14.65218,-8.769 30.75403,-35.77776 38.94632,-36.63607c0,-0.00113 -23.60591,45.80945 -38.94632,36.63607z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_9",
    fill: "#DC1D00",
    d: "m255.94075,291.87924c8.32858,15.51274 24.85846,33.76376 24.85846,33.76376s-6.32585,0.71301 -21.02533,4.31072c-14.70286,3.59771 -22.08302,7.33285 -22.08302,7.33285s0,0 6.03073,-13.51001c6.042,-13.51114 12.21916,-31.89732 12.21916,-31.89732z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_10",
    fill: "#DC1D00",
    d: "m420.59301,68.23755l0,389.84163l-338.98141,0l0,-291.08248l206.33572,0l0,-119.13454l-206.33572,0l0,-46.67115l272.15563,0l0.04844,0.06083l-0.04844,0.04844l0.61389,66.98573l65.70839,-0.04956l0.25794,-0.24555l0.24555,0.24668z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_11",
    fill: "#FFFFFF",
    d: "m210.10538,353.52247c-8.19116,0.85944 -53.59849,27.86707 -38.94632,36.63607c15.34041,9.17451 38.94632,-36.63607 38.94632,-36.63607zm85.01484,-24.81003c18.20146,17.32962 47.80205,23.98776 47.80205,7.65274c0,-16.32375 -47.80205,-7.65274 -47.80205,-7.65274zm-14.32102,-3.07056c0,0 -16.53101,-18.24989 -24.85846,-33.76376c0,0 -6.17716,18.38618 -12.22029,31.89619c-6.03073,13.51001 -6.03073,13.51001 -6.03073,13.51001s7.38128,-3.73401 22.08302,-7.33285c14.70061,-3.59659 21.02646,-4.3096 21.02646,-4.3096zm-31.7599,-60.63622c0,0 7.90844,-24.13306 7.76313,-36.50091c-0.14981,-12.35545 -4.16429,-14.07546 -7.76313,-14.07546c-3.58645,0 -8.18102,3.88044 -8.18102,18.10233c0,14.22302 5.45289,29.60172 8.18102,32.47404zm9.92356,18.6813c8.04586,17.39045 30.17731,39.79337 30.17731,39.79337s7.1729,-1.86644 36.77237,-2.57832c29.61073,-0.71301 30.90159,15.94078 31.03563,17.37806c0.14756,1.44967 1.30324,14.66569 -22.26662,15.52401c-23.55635,0.86057 -47.99692,-23.70391 -47.99692,-23.70391s-10.04746,1.58371 -18.37492,3.58758c-8.32746,2.01287 -35.06475,9.34572 -35.06475,9.34572s-7.90956,14.36945 -25.43631,37.34908c-17.53801,22.99202 -37.17675,21.27314 -42.77832,13.65644c-6.50945,-8.84222 -1.48572,-17.67092 10.86973,-29.16919c12.35545,-11.49489 40.86232,-21.02646 40.86232,-21.02646s5.74801,-10.34145 14.17346,-30.07819c8.42433,-19.73673 14.79974,-39.5602 14.79974,-39.5602s-8.33985,-18.93812 -9.96186,-35.05236c-1.81688,-17.96829 0.19712,-30.04102 13.98986,-30.18858c13.79386,-0.14756 18.10346,10.20629 18.53374,28.16106c0.42916,17.97054 -9.33446,46.56189 -9.33446,46.56189z"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    id: "svg_12"
  }, /*#__PURE__*/React.createElement("polygon", {
    stroke: "null",
    id: "svg_13",
    fill: "#A51600",
    points: "227.31109619140625,91.087646484375 227.31109619140625,80.95006561279297 195.77198791503906,80.95006561279297 195.77198791503906,133.8907470703125 207.03594970703125,133.8907470703125 207.03594970703125,112.48919677734375 226.18470764160156,112.48919677734375 226.18470764160156,103.47801971435547 207.03594970703125,103.47801971435547 207.03594970703125,91.087646484375 "
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_14",
    fill: "#A51600",
    d: "m178.9819,86.23062c-5.10934,-3.85678 -11.88124,-5.6624 -21.95236,-5.6624c-6.05439,0 -11.94544,0.39311 -16.45103,1.105l0,52.05082c3.37919,0.39311 7.64486,0.7851 13.85919,0.7851c10.37863,0 19.00345,-2.19873 24.57912,-6.84061c5.10934,-4.32311 8.86925,-11.3248 8.86925,-21.46913c0,-9.34459 -3.38933,-15.87882 -8.90417,-19.96877zm-22.33871,38.92153c-1.48572,0 -2.54791,0 -4.80071,-0.23316l0,-34.67276c2.25279,-0.23316 3.3882,-0.47872 6.06678,-0.47872c10.29189,0 16.73939,5.82122 16.66505,16.82612c0,12.66296 -7.0749,18.64413 -17.93112,18.55852z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_15",
    fill: "#A51600",
    d: "m127.79164,84.81812c-3.53689,-2.83739 -9.30292,-4.24877 -16.69771,-4.24877c-7.30807,0 -13.31852,0.47872 -16.69771,1.105l0,52.2164l12.39037,0l0,-18.88405c1.1264,0.15995 2.75855,0.24555 4.33212,0.24555c7.07378,0 13.24869,-1.7324 17.33976,-5.58806c3.14378,-2.98383 4.93475,-7.39367 4.93475,-12.57623c0,-5.19494 -2.22463,-9.5924 -5.60157,-12.26985zm-16.7484,21.23597c-1.73127,0 -3.13026,-0.08561 -4.25666,-0.31877l0,-15.64791c1.1264,-0.23316 2.75855,-0.46633 5.18931,-0.46633c5.9823,0 9.35924,2.89822 9.35924,7.77439c0,5.42811 -3.93,8.65862 -10.29189,8.65862z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.0d48ff35c502ccb7a4eca2cbd5b7734a.svg";
export { ForwardRef as ReactComponent };